import { useState } from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { useTheme } from '@mui/material/styles'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import 'dayjs/locale/it'

import { fromStringToTime } from '../hooks/utils-functions'
import { colours } from '../settings/settings'

const MyTimePicker = ({
  value,
  onChange,
  autoFocus = false,
  disabled = false,
  error = false,
  readOnly = false,
  label = '',
  variant = 'filled',
  minTime = '09:00',
  maxTime = '21:45',
  mode,
}) => {
  const isMobile = useSelector(state => state.home.isMobile)

  const [hasBlurred, setHasBlurred] = useState()
  const [validationError, setValidationError] = useState()

  // workaround for TimePicker since v8
  const handleBlur = event => {
    const currentTarget = event.currentTarget
    requestAnimationFrame(() => {
      if (!currentTarget.contains(document.activeElement)) setHasBlurred(true)
    })
  }

  const isError =
    (mode === 'update' || ((!mode || mode === 'add') && hasBlurred)) &&
    (error || validationError)

  const minTimeDate = fromStringToTime(minTime)
  const maxTimeDate = fromStringToTime(maxTime)
  const minHour = minTimeDate.getHours()
  const minMinute = minTimeDate.getMinutes()
  const maxHour = maxTimeDate.getHours()
  const maxMinute = maxTimeDate.getMinutes()
  const minTimeJs = dayjs().set('hour', minHour).set('minute', minMinute)
  const maxTimeJs = dayjs().set('hour', maxHour).set('minute', maxMinute)

  const theme = useTheme()
  const errTextColor = theme.palette.error.main
  const errBackColor = colours.redError

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='it'>
      <TimePicker
        value={
          value && dayjs(value, 'HH:mm')?.isValid()
            ? dayjs(value, 'HH:mm')
            : null
        }
        onChange={i => onChange && onChange(i?.format('HH:mm'))}
        onClose={() => setHasBlurred(true)}
        onError={i => setValidationError(!!i)}
        autoFocus={!!autoFocus}
        disabled={!!disabled}
        readOnly={!!readOnly}
        skipDisabled
        label={label}
        format='HH:mm'
        minTime={minTimeJs.startOf('minute')}
        maxTime={maxTimeJs.startOf('minute')}
        minutesStep={15}
        timeSteps={{ minutes: 15 }}
        localeText={{
          fieldClearLabel: 'Cancella',
          clearButtonLabel: 'Cancella',
          cancelButtonLabel: 'Annulla',
          timePickerToolbarTitle: 'Seleziona orario',
        }}
        slotProps={{
          actionBar: { actions: isMobile ? ['accept', 'cancel'] : ['accept'] },
          field: { onBlur: handleBlur },
          textField: {
            variant,
            clearable: true,
            fullWidth: true,
            error: isError,
            sx: {
              '& .MuiPickersInputBase-root': {
                color: isError && errTextColor,
                backgroundColor:
                  (disabled && 'transparent') || (isError && errBackColor),
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  )
}

export default MyTimePicker
